<template>
  <div>
    <a-table :bordered="false" :dataSource="dataSource" :columns="columns" :pagination="false">
      <template slot="name" slot-scope="text, record">
        <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />
      </template>
      <template slot="operation" slot-scope="text, record">
        <a
          @click="() => editChild(record)"
        >修改</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          v-if="dataSource.length"
          title="确定删除这条吗"
          @confirm="() => onDelete(record)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <a-button type="dashed" :disabled="showable" style="width: 100%" @click="$refs.biddingRemarkAdd.edit(null, 'add')">
      <a-icon type="plus" /> 添加备注
    </a-button>
    <bidding-remark-add
      @changeData="changeData"
      @editData="editData"
      ref="biddingRemarkAdd"
    />
  </div>
</template>

<script>
import biddingRemarkAdd from './biddingRemarkAdd'
import { Ellipsis } from '@/components'
export default {
  name: 'BiddingRemarkList',
  components: {
    biddingRemarkAdd,
    Ellipsis
  },
  data () {
    return {
      showable: false,
      count: 0,
      type: '',
      dataSource: [],
      deleteList: [],
      columns: [
        {
          title: '日期',
          width: '150px',
          dataIndex: 'remarkDate'
        },
        {
          title: '标题',
          width: '300px',
          dataIndex: 'headline',
          customRender: (text) => {
            return (
              <ellipsis length={30} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '备注内容',
          width: '600px',
          dataIndex: 'content',
          customRender: (text) => {
            return (
              <ellipsis length={100} tooltip>{text}</ellipsis>
            )
          }
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  methods: {
    uploadData () {
      const toParentSource = {
        dataSource: this.dataSource,
        deleteList: this.deleteList }
      this.$emit('getData', toParentSource)
    },
    loadData (data, type) {
      this.dataSource = data
      data.forEach(da => {
        da.key = this.count
        this.count = this.count + 1
      })
      if (type === 'show') {
        this.showable = true
      } else {
        this.showable = false
      }
    },
    onCellChange (key, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
      }
    },
    changeData (value) {
      const { count, dataSource } = this
      const newData = value
      newData.key = count
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    editData (value) {
      const newData = value
      const dataSource = [...this.dataSource]
      const index = this.dataSource.filter(item => item.key === value.key).map(data => data.key)
      this.dataSource = dataSource.filter(item => item.key !== value.key)
      this.dataSource.splice(index, 0, newData)
    },
    editChild (record) {
      this.$refs.biddingRemarkAdd.edit(record, 'edit')
    },
    onDelete (record) {
      const key = record.key
      const id = record.id
      console.log(id)
      console.log(key)
      const dataSource = [...this.dataSource]
      const deleteList = [...this.deleteList]
      if (typeof (id) !== 'undefined' && id != null) {
        for (let i = 0; i < dataSource.length; i++) {
          if (dataSource[i].id === id) {
            deleteList.push(this.dataSource[i].id)
          }
        }
        this.dataSource = dataSource.filter(item => item.id !== id)
      }
      if (typeof (key) !== 'undefined' && key != null) {
        this.dataSource = dataSource.filter(item => item.key !== key)
      }
      this.deleteList = deleteList
    }
  }
}
</script>

<style scoped>

</style>
